module.exports = __webpack_public_path__ + "static/media/Nunito-Italic.80150d05.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Nunito/Nunito-Italic.ttf
// module id = 301
// module chunks = 0